//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import '@legacy-components/common/universal-image-actions/universal-image-actions-one-page';

import { UniversalImageActionsView } from '@models/UniversalImageActionsView';

(function () {
  const curalate = angular.module('curalate');
  const uia = angular.module('uia');

  curalate.constant('UniversalImageActionsView', UniversalImageActionsView);

  curalate.constant('UniversalImageActionsNetworkTypes', [
    'pinterest',
    'facebook',
    'instagram',
    'twitter',
    'tumblr',
  ]);

  curalate.constant('ShareWarningNote', {
    username: 'Bazaarvoice',
    clientName: 'Only visible to you',
    text: 'Heads up! This item was shared, so any additional notes you add will be visible to the share partner.',
  });

  uia.constant('UniversalImageActionWorkflows', {
    ApproveForFanreel: 'ApproveForFanreel',
    CreateReveal: 'CreateReveal',
    CreateOnePage: 'CreateOnePage',
    CreateAdaptiveLink: 'CreateAdaptiveLink',
    ScheduleNow: 'ScheduleNow',
  });

  curalate.constant('PRODUCT_RESULTS_TYPES', {
    CATALOG_RESULTS: 'catalog-results',
    CATALOG_SUGGESTIONS: 'catalog-suggestions',
    CRAWL_RESULT: 'crawl-result',
    NO_CATALOG: 'no-catalog',
    NO_RESULTS: 'no-results',
  });
})();
